import React from 'react';
import { 
  Calculator, ShieldCheck, Cloud, Smartphone, 
  Languages, Database, Binary, Code2, 
  BookText, Palette 
} from 'lucide-react';

const courses = [
  { name: "Math", icon: <Calculator size={28} /> },
  { name: "Cyber Security", icon: <ShieldCheck size={28} /> },
  { name: "Cloud Computing", icon: <Cloud size={28} /> },
  { name: "Mobile App", icon: <Smartphone size={28} /> },
  { name: "French", icon: <Languages size={28} /> },
  { name: "Data Science", icon: <Database size={28} /> },
  { name: "Python", icon: <Binary size={28} /> },
  { name: "Web Dev", icon: <Code2 size={28} /> },
  { name: "English", icon: <BookText size={28} /> },
  { name: "Product Design", icon: <Palette size={28} /> },
];

const InfiniteCourseScroll = () => {
  // Triple the list for a truly seamless transition at high speeds
  const scrollItems = [...courses, ...courses, ...courses];

  return (
    <div className="w-full bg-slate-50 py-16 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 mb-12">
        <h2 className="text-4xl font-extrabold text-slate-900 tracking-tight">
          Master Your <span className="text-[#1976D2]">Future</span>
        </h2>
        <p className="text-slate-500 mt-2">Explore industry-leading courses curated for you.</p>
      </div>

      {/* Main Perspective Container */}
      <div className="relative">
        {/* Sleek Gradient Fades for Left/Right edges */}
        <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-slate-50 to-transparent z-10" />
        <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-slate-50 to-transparent z-10" />

        <div className="flex animate-scroll-fast hover:[animation-play-state:paused] transition-all duration-500">
          {scrollItems.map((course, index) => (
            <div
              key={index}
              className="group relative flex-shrink-0 mx-4 w-56 h-36 bg-white rounded-3xl border border-white shadow-[0_10px_20px_rgba(0,0,0,0.05)] hover:shadow-[0_20px_40px_rgba(0,0,0,0.12)] hover:-translate-y-2 transition-all duration-300 cursor-pointer overflow-hidden flex flex-col items-start justify-center p-8"
              style={{ perspective: "1000px" }}
            >
              {/* 3D Inner Glow Effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-blue-50/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              
              {/* Icon with 3D Pop */}
              <div className="relative text-slate-700 group-hover:text-blue-600 group-hover:scale-110 group-hover:rotate-[10deg] transition-transform duration-300 mb-4">
                {course.icon}
              </div>
              
              <span className="relative text-base font-bold text-slate-800 tracking-wide">
                {course.name}
              </span>

              {/* Decorative background element */}
              <div className="absolute -bottom-2 -right-2 w-12 h-12 bg-blue-50 rounded-full blur-2xl group-hover:bg-blue-200 transition-colors" />
            </div>
          ))}
        </div>
      </div>

      {/* Logic for Seamless Speed */}
      <style>{`
        @keyframes scroll {
          from { transform: translateX(0); }
          to { transform: translateX(calc(-33.33%)); }
        }
        .animate-scroll-fast {
          display: flex;
          width: max-content;
          animation: scroll 40s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default InfiniteCourseScroll;